import React from 'react';
import { useParams } from 'react-router-dom';

const EventItemSkeleton = () => (
  <div className="tournament-scroll-event swipe skeleton-loader">
    <div className="tournament-scroll-event-info">
      <div className="tournament-scroll-event-card">
        <div className="title-line-3 skeleton" />
        <div className="title-line-3 skeleton" />
        <a href="/sportsbook?e=1708321">
          <div className="tournament-scroll-event-participants">
            <div className="event-participant">
              <div className="participant-container">
                <div className="title-line-2 skeleton" />
                <div className="title-line-2 skeleton" />
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div className="tournament-scroll-outcomes-row-container">
      <div className="tournament-scroll-outcomes-row">
        <div className="tournament-scroll-market">
          <div className="tournament-scroll-market-name">
            <div className="title-line-3 skeleton" />
          </div>
          <div className="market-row">
            <div className="outcome primary">
              <div className="skeleton-odds skeleton" />
            </div>
            <div className="outcome primary">
              <div className="skeleton-odds skeleton" />
            </div>
            <div className="outcome primary">
              <div className="skeleton-odds skeleton" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const EventSwipeGridLoader = () => {
  const { tournamentName } = useParams();
  const skeletonCount = tournamentName ? 1 : 10;

  return Array.from({ length: skeletonCount }).map((_, i) => <EventItemSkeleton key={i} />);
};

export default EventSwipeGridLoader;
